import { IContractCancellationCommunication } from 'modules/customer/domain/entities';

import { parseVectisDate } from './ContractCancellationTracking';

export interface IVectisContractCancellationCommunication {
  assunto: string;
  dataEnvio: string | null;
  etapa: string | null;
  descricaoEtapa: string | null;
}

export class ContractCancellationCommunication
  implements IContractCancellationCommunication
{
  public subject: IContractCancellationCommunication['subject'];
  public sentAt: IContractCancellationCommunication['sentAt'];
  public step: IContractCancellationCommunication['step'];
  public stepDescription: IContractCancellationCommunication['stepDescription'];

  constructor({
    assunto,
    dataEnvio,
    etapa,
    descricaoEtapa,
  }: IVectisContractCancellationCommunication) {
    this.subject = assunto;
    this.sentAt = parseVectisDate(dataEnvio);
    this.step = etapa ?? null;
    this.stepDescription = descricaoEtapa ?? null;
  }
}
